import { Component, EventEmitter, Input, OnChanges, Output, OnInit, OnDestroy } from '@angular/core';
import { ITEMS_PER_PAGE } from '../../shared/constants';
import "rxjs/add/operator/takeUntil";
import { Subject } from "rxjs/Subject";

@Component({
  selector: 'drx-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnInit, OnChanges, OnDestroy {
  /**
   * Define a Subject instance to handle unsubscription
   * @type {Subject<void>}
   */
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  public currentPage = 1;
  public range = 3;
  public pages: any;

  @Input() totalPages?: number;
  @Output() changePage: EventEmitter<any> = new EventEmitter();
  @Input() itemsPerPage?= ITEMS_PER_PAGE;
  @Input() resetPage?: Subject<any>; // Mode reset to first page

  public ngOnInit() {
    if (this.resetPage !== undefined) {
      // takeUntil operator to complete unsubcription
      this.resetPage
        .takeUntil(this.ngUnsubscribe)
        .subscribe(event => {
          if (event) {
            this.currentPage = 1;
          }
        }, (error) => {
          console.log(error);
        });
    }
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next(); // Emit a value
    this.ngUnsubscribe.complete(); // complete the observable
  }

  public ngOnChanges() {
    this.getPages();
  }

  public updateCurrentPage(page: number) {
    this.currentPage = page;
  }

  public selectPage(page: number) {
    if (page > this.totalPages) {
      page = this.totalPages;
    } else if (page < 1) {
      page = 1;
    }
    this.updateCurrentPage(page);
    this.getPages();
    this.changePage.emit(page);
  }

  public getPages() {
    this.pages = [-2, -1, 0, 1, 2]
      .map(offset => this.currentPage + offset)
      .filter(page => page > 0 && page <= this.totalPages);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/pagination/pagination.component.ts